import React from "react";

const Faq = () => {
  return (
    <React.Fragment>
      <>
        {/* faq area start */}
        <section className="nh_faq-area pt-100 pb-100">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-xl-6 col-lg-7 col-md-9">
                <div className="nh_section-area mb-40 text-center">
                  <span className="nh_section-subtitle">FAQS</span>
                  <h2 className="nh_section-title mb-0">
                    Frequently Asked Questions
                  </h2>
                </div>
              </div>
            </div>
            <div className="row align-items-center">
              <div className="col-lg-6">
                <div className="nh_faq-img mr-65 mb-40 mb-lg-0">
                  <img
                    src="assets/images/faq/1.webp"
                    alt=""
                    className="w-100"
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="nh_faq-content ml-20">
                  <div className="accordion pb-10" id="accordionExample">
                    <div className="accordion-item mb-20">
                      <h2 className="accordion-header" id="headingOne">
                        <button
                          className="accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseOne"
                          aria-expanded="true"
                          aria-controls="collapseOne"
                        >
                          What services does Mitra Recharge offer?
                        </button>
                      </h2>
                      <div
                        id="collapseOne"
                        className="accordion-collapse collapse show"
                        aria-labelledby="headingOne"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <p>
                            Mitra Recharge provides mobile recharge, DTH
                            recharge, and Google Play recharge services.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item mb-20">
                      <h2 className="accordion-header" id="headingTwo">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseTwo"
                          aria-expanded="false"
                          aria-controls="collapseTwo"
                        >
                          Is it safe to make payments on Mitra Recharge?
                        </button>
                      </h2>
                      <div
                        id="collapseTwo"
                        className="accordion-collapse collapse"
                        aria-labelledby="headingTwo"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <p>
                            Yes, we use secure payment gateways and advanced
                            encryption to ensure all transactions are safe.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item mb-20">
                      <h2 className="accordion-header" id="headingThree">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseThree"
                          aria-expanded="false"
                          aria-controls="collapseThree"
                        >
                          What payment methods are accepted?
                        </button>
                      </h2>
                      <div
                        id="collapseThree"
                        className="accordion-collapse collapse"
                        aria-labelledby="headingThree"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <p>
                            We accept multiple payment methods, including UPI,
                            credit/debit cards, and net banking.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item mb-20">
                      <h2 className="accordion-header" id="headingFour">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseFour"
                          aria-expanded="false"
                          aria-controls="collapseFour"
                        >
                          Is there a mobile app for Mitra Recharge?
                        </button>
                      </h2>
                      <div
                        id="collapseFour"
                        className="accordion-collapse collapse"
                        aria-labelledby="headingFour"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <p>
                            Yes, you can download our mobile app for a seamless
                            recharge experience on the go.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item mb-20">
                      <h2 className="accordion-header" id="headingFive">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseFive"
                          aria-expanded="false"
                          aria-controls="collapseFive"
                        >
                          How can I contact customer support?
                        </button>
                      </h2>
                      <div
                        id="collapseFive"
                        className="accordion-collapse collapse"
                        aria-labelledby="headingFive"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <p>
                            You can reach us via email at
                            mitrarechargeapp@gmail.com or call us at +91
                            9632456111.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <a href="/contact_us" className="nh_theme-btn">
                    Contact Us Now
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* faq area end */}
      </>
    </React.Fragment>
  );
};

export default Faq;
